import gql from 'graphql-tag';

export const getCoachingsAndContactReviewsQuery = gql`
  query GetCoachingsAndContactReviews(
    $presetDate: PresetDate!
    $reviewTypes: [ReviewTypes!]
    $directReports: [UserInfo!]
  ) {
    getCoachingsAndContactReviews(
      presetDate: $presetDate
      reviewTypes: $reviewTypes
      directReports: $directReports
    ) {
      coachingNotes {
        closedAt
        coachingId
        createdAt
        deliveredAt
        recipient {
          userID
          userName
        }
        id
        isDelivered
        reviewedAt
      }

      contactReviews {
        agentUserName
        agentUserID
        contactID
        deliveredAt
        contactStatus
      }
    }
  }
`;

export const getActiveCsasQuery = gql`
  query GetActiveCsas($vertical: String!, $directReports: [String!]!) {
    getActiveCsas(vertical: $vertical, directReports: $directReports) {
      activeCsas
    }
  }
`;

export const getTrendsMetricsQuery = gql`
  query GetTrendsMetrics(
    $channel: String!
    $marketplace: String
    $presetDate: String!
    $segment: String!
    $skill: String!
    $team: [String!]!
    $userID: String!
    $vertical: String!
    $customDates: [String!]
    $customMetrics: [LighthouseMetricOption!]
    $isHistorical: Boolean
  ) {
    getTrendsMetrics(
      channel: $channel
      marketplace: $marketplace
      presetDate: $presetDate
      segment: $segment
      skill: $skill
      team: $team
      userID: $userID
      vertical: $vertical
      customDates: $customDates
      customMetrics: $customMetrics
      isHistorical: $isHistorical
    ) {
      latestMetricPublishDate
      metricTypes
      userID
      metricDatas {
        trend {
          name
          trendDatapoint {
            datapoint
            name
            networkAverage
            timestamp
          }
        }
      }
    }
  }
`;

export const getTeamDetailsMetricsQuery = gql`
  query GetTeamDetailsMetrics(
    $channel: String!
    $customDates: [String]
    $customMetrics: [LighthouseMetricOption]
    $isTM: [Boolean!]!
    $marketplace: String
    $presetDate: String!
    $segment: String!
    $skill: String!
    $team: [String!]!
    $userID: String!
    $vertical: String!
    $syncMetrics: Boolean
  ) {
    getTeamDetailsMetrics(
      channel: $channel
      customDates: $customDates
      customMetrics: $customMetrics
      isTM: $isTM
      marketplace: $marketplace
      presetDate: $presetDate
      segment: $segment
      skill: $skill
      team: $team
      userID: $userID
      vertical: $vertical
      syncMetrics: $syncMetrics
    ) {
      latestMetricPublishDate
      metricDatas {
        baseMetric {
          datapoint
          name
          networkAverage
        }
        trend {
          name
          trendDatapoint {
            datapoint
            name
            networkAverage
            timestamp
          }
        }
      }
      metricTypes
      userID
    }
  }
`;
